import React, { Suspense, lazy } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import { AppHeader, AppFooter, LoadingFrame } from "./components/shared";
import DefaultWrapperRoute from "./components/DefaultWrapperRoute/DefaultWrapperRoute";

import { ScrollTop } from "./components/shared/utils";
import { Layout } from "antd";

const Homepage = lazy(() => import("./components/pages/Homepage/Homepage"));
const Accountpage = lazy(() =>
  import("./components/pages/Accountpage/Accountpage")
);
const Prices = lazy(() => import("./components/pages/Data/Prices/Prices"));
const Foundation = lazy(() =>
  import("./components/pages/Data/Foundation/Foundation")
);
const Blockspage = lazy(() =>
  import("./components/pages/Blockchain/Blockspage/Blockspage")
);
const Transferspage = lazy(() =>
  import("./components/pages/Blockchain/Transferspage/Transferspage")
);
const Conversionspage = lazy(() =>
  import("./components/pages/Blockchain/Conversionspage/Conversionspage")
);
const Accountspage = lazy(() =>
  import("./components/pages/Accountspage/Accountspage")
);
const Transactionpage = lazy(() =>
  import("./components/pages/Transactionpage/Transactionpage")
);
const Burnpage = lazy(() => import("./components/pages/Burnpage/Burnpage"));
const Contractpage = lazy(() =>
  import("./components/pages/Contractpage/Contractpage")
);
const Tokenpage = lazy(() => import("./components/pages/Tokenpage/Tokenpage"));
const NotFound = lazy(() => import("./components/pages/NotFound/NotFound"));
const Searchpage = lazy(() =>
  import("./components/pages/Searchpage/Searchpage")
);

function Routes({ store }) {
  return (
    <Suspense fallback={<LoadingFrame />}>
      <Provider store={store}>
        <Router>
          <ScrollTop />
          <Layout>
            <AppHeader />
            <Suspense fallback={<LoadingFrame />}>
              <Switch>
                <DefaultWrapperRoute path="/" exact component={Homepage} />
                <DefaultWrapperRoute
                  path="/account/:account"
                  exact
                  component={Accountpage}
                />
                <DefaultWrapperRoute
                  path="/contract/:contractAddress"
                  exact
                  component={Contractpage}
                />
                <DefaultWrapperRoute
                  path="/transaction/:transactionId"
                  exact
                  component={Transactionpage}
                />
                <DefaultWrapperRoute
                  path="/blockchain/blocks"
                  exact
                  component={Blockspage}
                />
                <DefaultWrapperRoute
                  path="/blockchain/transfers"
                  exact
                  component={Transferspage}
                />
                <DefaultWrapperRoute
                  path="/blockchain/transactions"
                  exact
                  component={Conversionspage}
                />
                <DefaultWrapperRoute
                  path="/holders"
                  exact
                  component={Accountspage}
                />
                <DefaultWrapperRoute path="/burn" exact component={Burnpage} />
                <DefaultWrapperRoute
                  path="/tokens/:tokenName"
                  exact
                  component={Tokenpage}
                />
                <DefaultWrapperRoute
                  path="/data/prices"
                  exact
                  component={Prices}
                />
                <DefaultWrapperRoute
                  path="/data/foundation"
                  exact
                  component={Foundation}
                />
                <DefaultWrapperRoute
                  path="/search/:query"
                  exact
                  component={Searchpage}
                />
                <Route path="*">
                  <NotFound />
                </Route>
              </Switch>
            </Suspense>
            <AppFooter />
          </Layout>
        </Router>
      </Provider>
    </Suspense>
  );
}

export default Routes;
